// loanDrilldownIndex.js

export const LOAN_DRILLDOWN_INDEX = [
  // -----------------------------
  // LOAN INFORMATION (existing)
  // -----------------------------
  {
    label: "Loan Details",
    path: "loan-information",
    isRoute: true,
    includes: ["Loan Information", "Loan Info", "Details", "Terms", "Meta"],
    children: [
      {
        label: "Loan Meta",
        path: "loan-meta",
        includes: ["Meta", "Pipeline", "Loan Product Type", "Loan Purpose"],
        children: [
          {
            label: "Create Date Time",
            path: "createDateTime",
            includes: ["Create Date"],
          },
          {
            label: "Update Date Time",
            path: "updateDateTime",
            includes: ["Update Date"],
          },
          { label: "Loan Number", path: "loanNumber", includes: ["Number"] },
          {
            label: "External Loan Sync ID",
            path: "sync_loan_id",
            includes: ["Sync ID", "External ID"],
          },
          { label: "Loan Name", path: "loanName", includes: ["Name"] },
          {
            label: "Loan Product Type",
            path: "loanProductType",
            includes: ["Product Type"],
          },
          { label: "Loan Purpose", path: "loanPurpose", includes: ["Purpose"] },
          { label: "Term Months", path: "termMonths", includes: ["Term"] },
          { label: "Exit Strategy", path: "exitStrategy", includes: ["Exit"] },
          { label: "DSCR", path: "dscr", includes: ["Debt Service Coverage"] },
          {
            label: "Total In Place Rents",
            path: "totalInPlaceRents",
            includes: ["In Place Rents"],
          },
          {
            label: "Total Market Rents",
            path: "totalMarketRents",
            includes: ["Market Rents"],
          },
          {
            label: "Current Pipeline",
            path: "pipeline",
            includes: ["Pipeline Type"],
          },
        ],
      },

      {
        label: "Loan Terms",
        path: "loan-terms",
        includes: [
          "Loan Terms",
          "Interest Rate",
          "Discount Points",
          "Holdback",
        ],
        children: [
          {
            label: "Base Loan Amount",
            path: "baseLoanAmount",
            includes: ["Loan Amount", "Base Amount"],
          },
          {
            label: "Total Holdback",
            path: "totalHoldback",
            includes: ["Holdback"],
          },
          {
            label: "Required Interest Coverage",
            path: "requiredInterestCoverage",
            includes: ["Interest Coverage"],
          },
          {
            label: "Required Liquidity",
            path: "requiredLiquidity",
            includes: ["Liquidity"],
          },
          {
            label: "Total Interest Reserves",
            path: "totalInterestReserves",
            includes: ["Interest Reserves"],
          },
          { label: "Funded Date", path: "fundedDate", includes: ["Funded"] },
          {
            label: "Maturity Date",
            path: "maturityDate",
            includes: ["Maturity"],
          },
          {
            label: "Expected Closing Date",
            path: "expectedClosingDate",
            includes: ["Closing Date"],
          },
          { label: "Interest Rate", path: "interestRate", includes: ["Rate"] },
          {
            label: "Discount Points",
            path: "discountPoints",
            includes: ["Discount"],
          },
          {
            label: "Origination Points",
            path: "originationPoints",
            includes: ["Origination"],
          },
          {
            label: "Floating Rate Loan?",
            path: "floatingRateLoan",
            includes: ["Floating Rate"],
          },
          {
            label: "Floating Rate Base Rate",
            path: "floatingRateLoanBaseRate",
            includes: ["Base Rate"],
          },
          {
            label: "Floating Rate Floor Rate",
            path: "floatingRateLoanFloorRate",
            includes: ["Floor Rate"],
          },
          {
            label: "Floating Rate Cap Rate",
            path: "floatingRateLoanCapRate",
            includes: ["Cap Rate"],
          },
          {
            label: "Floating Rate Index",
            path: "floatingRateLoanRateIndex",
            includes: ["Rate Index"],
          },
          {
            label: "Floating Rate Margin",
            path: "floatingRateLoanRateMargin",
            includes: ["Margin"],
          },
        ],
      },

      {
        label: "Interest Reserves By Property",
        path: "interest-reserves",
        includes: ["Interest Reserves", "Reserves", "Property Reserves"],
      },

      {
        label: "Refinance Info",
        path: "refinance-info",
        includes: [
          "Refinance",
          "Refinancing",
          "Amortization",
          "Existing Lender",
        ],
        children: [
          {
            label: "Refinancing Asset Id",
            path: "refinancingAssetId",
            includes: ["Asset Id", "Refi Asset"],
          },
          {
            label: "Closing As Entity?",
            path: "closingAsEntity",
            includes: ["Entity Closing"],
          },
          {
            label: "Amortization Type",
            path: "amortizationType",
            includes: ["Amortization"],
          },
          {
            label: "Interest Calc Type",
            path: "interestCalcType",
            includes: ["Interest Calculation"],
          },
          {
            label: "Outstanding Loan UPB",
            path: "outstandingLoanUpb",
            includes: ["UPB", "Outstanding"],
          },
          {
            label: "Existing Lender",
            path: "exisitingLender",
            includes: ["Lender"],
          },
        ],
      },

      {
        label: "Prepayment",
        path: "prepayment",
        includes: ["Prepayment", "Penalty", "VOM"],
        children: [
          {
            label: "VOM Payment History",
            path: "vomPaymentHistory",
            includes: ["Payment History"],
          },
          {
            label: "Prepayment Structure",
            path: "prepaymentPenaltyStructure",
            includes: ["Penalty Structure"],
          },
        ],
      },

      {
        label: "Loan Closing",
        path: "loan-closing",
        includes: ["Closing", "Funding Shield", "Terms Accepted", "Wire"],
        children: [
          {
            label: "Closing Status",
            path: "closingStatus",
            includes: ["Status"],
          },
          {
            label: "Closing Scheduled?",
            path: "closingScheduled",
            includes: ["Scheduled"],
          },
          {
            label: "Closing Scheduled Date",
            path: "closingScheduledDate",
            includes: ["Scheduled Date"],
          },
          {
            label: "Funding Shield Status",
            path: "fundingShieldStatus",
            includes: ["Shield Status"],
          },
          {
            label: "Funding Shield Requested Date",
            path: "fundingShieldRequestedDate",
            includes: ["Shield Requested"],
          },
          {
            label: "Origination Date",
            path: "originationDate",
            includes: ["Origination"],
          },
          {
            label: "Terms Accepted?",
            path: "termsAccepted",
            includes: ["Accepted"],
          },
          {
            label: "Terms Accepted Date",
            path: "termsAcceptedDate",
            includes: ["Accepted Date"],
          },
          { label: "Wire Status", path: "wireStatus", includes: ["Wire"] },
          {
            label: "Wire Sent Date",
            path: "wireSentDate",
            includes: ["Wire Date"],
          },
        ],
      },

      {
        label: "Dead Deal",
        path: "dead-deal",
        includes: ["Dead", "Deal Dead", "Reason", "Notes"],
        children: [
          {
            label: "Deal Dead Reason",
            path: "dealDeadReason",
            includes: ["Dead Reason"],
          },
          {
            label: "Deal Dead Notes",
            path: "dealDeadNotes",
            includes: ["Dead Notes"],
          },
        ],
      },
    ],
  },

  // -----------------------------
  // FEES & CLOSING (updated to match routed subtabs)
  // -----------------------------
  {
    label: "Fees & Closing",
    path: "fees-and-closing",
    isRoute: true,
    includes: ["Closing", "Fees", "Wire", "Terms Sheet", "Escrow"],
    children: [
      {
        label: "Loan Terms Sheet",
        path: "loan-terms",
        isRoute: true,
        includes: ["Terms Sheet", "Loan Terms"],
      },
      {
        label: "Originator Fees",
        path: "originator-fees",
        isRoute: true,
        includes: ["Originator", "Fees"],
      },
      {
        label: "Originator Credits",
        path: "originator-credits",
        isRoute: true,
        includes: ["Originator", "Credits"],
      },
      {
        label: "Third Party Fees",
        path: "third-party-fees",
        isRoute: true,
        includes: ["Third Party", "Fees"],
      },
      {
        label: "Correspondent Fees",
        path: "correspondent-fees",
        isRoute: true,
        includes: ["Correspondent", "Fees"],
      },
      {
        label: "Broker Terms",
        path: "broker-terms",
        isRoute: true,
        includes: ["Broker", "Terms"],
      },
      {
        label: "Escrow Items",
        path: "escrow",
        isRoute: true,
        includes: ["Escrow", "Items"],
      },
      {
        label: "Wire Instructions",
        path: "wire-instructions",
        isRoute: true,
        includes: ["Wire", "Instructions", "Fed Ref", "Wire Amount"],
        children: [
          {
            label: "Wire Request Date",
            path: "wireRequestDate",
            includes: ["Request Date"],
          },
          { label: "Wire Amount", path: "wireAmount", includes: ["Amount"] },
          { label: "Wire Status", path: "wireStatus", includes: ["Status"] },
          {
            label: "Wire Fed Ref Number",
            path: "wireFedRefNumber",
            includes: ["Fed Ref"],
          },
          {
            label: "Closing Wire Release Date",
            path: "closingWireReleaseDate",
            includes: ["Release Date"],
          },
          {
            label: "Wire Remarks/Notes",
            path: "wireNotes",
            includes: ["Notes", "Remarks"],
          },
        ],
      },
      {
        label: "Funding Shield (Beta)",
        path: "funding-shield",
        isRoute: true,
        includes: ["Funding Shield", "Shield"],
      },
    ],
  },

  // -----------------------------
  // PROPERTIES (new)
  // -----------------------------
  {
    label: "Properties",
    path: "properties",
    isRoute: true,
    includes: ["Property", "Properties", "Subject Property", "Collateral"],
    children: [
      {
        label: "Property Details",
        path: "property-details",
        includes: ["Property Details", "Flood", "Listed", "Rural"],
        children: [
          { label: "Property Type", path: "propertyType", includes: ["Type"] },
          {
            label: "Proposed Property Type",
            path: "proposedPropertyType",
            includes: ["Proposed Type"],
          },
          {
            label: "Property Rural Indicator",
            path: "propertyRuralIndicator",
            includes: ["Rural"],
          },
          { label: "Flood Zone", path: "floodZone", includes: ["Flood"] },
          {
            label: "Flood Cert Date",
            path: "floodCertDate",
            includes: ["Flood Cert"],
          },
          {
            label: "Property Listed For Sale",
            path: "propertyListedForSale",
            includes: ["Listed For Sale"],
          },
          {
            label: "Last Listed For Sale Date",
            path: "lastListedForSaleDate",
            includes: ["Last Listed Date"],
          },
          {
            label: "Last Listed For Sale Price",
            path: "lastListedForSalePrice",
            includes: ["Last Listed Price"],
          },
        ],
      },
      {
        label: "Valuation Info",
        path: "valuation-info",
        includes: ["Valuation", "ARV", "Appraisal", "As-Is Value"],
        children: [
          {
            label: "As-Is Value",
            path: "asIsValue",
            includes: ["As Is Value"],
          },
          {
            label: "Secondary As-Is Value",
            path: "secondaryAsIsValue",
            includes: ["Secondary As Is"],
          },
          {
            label: "Secondary As-Is Variance",
            path: "secondaryAsIsVariance",
            includes: ["Variance"],
          },
          { label: "After Repair Value (ARV)", path: "arv", includes: ["ARV"] },
          {
            label: "Secondary ARV",
            path: "secondaryArv",
            includes: ["Secondary ARV"],
          },
          {
            label: "Appraisal Date",
            path: "appraisalDate",
            includes: ["Appraisal"],
          },
          {
            label: "Secondary Appraisal Date",
            path: "secondaryAppraisalDate",
            includes: ["Secondary Appraisal"],
          },
        ],
      },
      {
        label: "Purchase Info",
        path: "purchase-info",
        includes: ["Purchase", "Cost Basis", "Assignment Fees"],
        children: [
          {
            label: "Purchase Price",
            path: "purchasePrice",
            includes: ["Price"],
          },
          { label: "Purchase Date", path: "purchaseDate", includes: ["Date"] },
          { label: "Cost Basis", path: "costBasis", includes: ["Basis"] },
          {
            label: "Additional Basis",
            path: "additionalBasis",
            includes: ["Additional"],
          },
          {
            label: "Assignment Fees",
            path: "assignmentFees",
            includes: ["Assignment"],
          },
          {
            label: "Seller's Concession",
            path: "sellersConcession",
            includes: ["Concession"],
          },
        ],
      },
      {
        label: "Construction/Rehab",
        path: "construction-rehab",
        includes: ["Construction", "Rehab", "Budget", "Interest Reserves"],
        children: [
          {
            label: "Construction Budget",
            path: "constructionBudget",
            includes: ["Budget"],
          },
          {
            label: "Interest Reserves",
            path: "interestReserves",
            includes: ["Reserves"],
          },
          {
            label: "Financed Budget",
            path: "financedBudget",
            includes: ["Financed"],
          },
          {
            label: "Financed Budget Percent",
            path: "financedBudgetPercent",
            includes: ["Financed Percent"],
          },
          {
            label: "Budget Is Final",
            path: "budgetIsFinal",
            includes: ["Final Budget"],
          },
          {
            label: "Budget Matches Appraisal",
            path: "budgetMatchesAppraisal",
            includes: ["Matches Appraisal"],
          },
          {
            label: "Final Budget Uploaded",
            path: "finalBudgetUploaded",
            includes: ["Uploaded"],
          },
          {
            label: "Final Budget Feasible",
            path: "finalBudgetFeasible",
            includes: ["Feasible"],
          },
        ],
      },
      {
        label: "Units/Square Footage",
        path: "units-square-footage",
        includes: ["Units", "Square Footage", "Sq Ft"],
        // add children later when fields are enumerated
      },
      {
        label: "Property Condition",
        path: "property-condition",
        includes: ["Condition", "Status"],
        children: [
          {
            label: "Condition at Origination",
            path: "propertyConditionAtOrigination",
            includes: ["Origination Condition"],
          },
          {
            label: "Status at Origination",
            path: "propertyStatusAtOrigination",
            includes: ["Origination Status"],
          },
        ],
      },
      {
        label: "Expenses",
        path: "expenses",
        includes: ["Taxes", "Insurance", "HOA", "Expenses"],
        children: [
          { label: "Annual Taxes", path: "annualTaxes", includes: ["Taxes"] },
          {
            label: "Annual Insurance",
            path: "annualInsurance",
            includes: ["Insurance"],
          },
          {
            label: "Annual Flood Insurance",
            path: "annualFloodInsurance",
            includes: ["Flood Insurance"],
          },
          {
            label: "Annual HOA Fees",
            path: "annualHoaFees",
            includes: ["HOA"],
          },
          {
            label: "Annual Property Mgmt Fees",
            path: "annualPropertyMgmtFees",
            includes: ["Property Mgmt", "Management"],
          },
          {
            label: "Annual Other Expense",
            path: "annualOtherExpense",
            includes: ["Other Expense"],
          },
          {
            label: "Monthly Taxes",
            path: "monthlyTaxes",
            includes: ["Monthly Taxes"],
          },
          {
            label: "Monthly Insurance",
            path: "monthlyInsurance",
            includes: ["Monthly Insurance"],
          },
          {
            label: "Monthly Flood Insurance",
            path: "monthlyFloodInsurance",
            includes: ["Monthly Flood Insurance"],
          },
          {
            label: "Monthly HOA Fees",
            path: "monthlyHoaFees",
            includes: ["Monthly HOA"],
          },
          {
            label: "Monthly Property Mgmt Fees",
            path: "monthlyPropertyMgmtFees",
            includes: ["Monthly Mgmt", "Management"],
          },
          {
            label: "Monthly Other Expense",
            path: "monthlyOtherExpense",
            includes: ["Monthly Other"],
          },
        ],
      },
    ],
  },

  // -----------------------------
  // BORROWERS (new)
  // -----------------------------
  {
    label: "Borrowers",
    path: "borrowers",
    isRoute: true,
    includes: ["Borrower", "Borrowers", "Guarantor", "Applicant"],
    children: [
      {
        label: "Borrower Info",
        path: "borrower-info",
        includes: ["Name", "Email", "Phone", "DOB", "Citizenship", "SSN"],
        children: [
          { label: "First Name", path: "firstName", includes: ["First"] },
          { label: "Middle Name", path: "middleName", includes: ["Middle"] },
          { label: "Last Name", path: "lastName", includes: ["Last"] },
          { label: "Email", path: "emailAddress", includes: ["Email Address"] },
          { label: "Phone", path: "phone", includes: ["Phone Number"] },
          { label: "Date of Birth", path: "dateOfBirth", includes: ["DOB"] },
          {
            label: "Primary Address",
            path: "primaryAddress",
            includes: ["Address"],
          },
          {
            label: "Borrower Citizenship",
            path: "citizenshipStatus",
            includes: ["Citizenship"],
          },
          {
            label: "Marital Status",
            path: "maritalStatus",
            includes: ["Married", "Not Married"],
          },
          {
            label: "Does borrower have a US issued SSN?",
            path: "borrowerHasSSN",
            includes: ["SSN Flag"],
          },
          {
            label: "Social Security Number",
            path: "borrowerSSN",
            includes: ["SSN"],
          },
          {
            label: "Additional Borrower Notes",
            path: "additional_borrower_notes",
            includes: ["Notes"],
          },
        ],
      },

      {
        label: "Liquidity",
        path: "liquidity",
        includes: ["Liquidity", "Cash", "Accounts"],
        children: [
          {
            label: "Total Cash Liquidity",
            path: "cashLiquidity",
            includes: ["Cash Liquidity"],
          },
          {
            label: "Total Value of Other Liquidity Sources",
            path: "otherLiquidity",
            includes: ["Other Liquidity"],
          },
        ],
      },

      {
        label: "Credit",
        path: "credit",
        includes: ["FICO", "Credit Report", "Authorization"],
        children: [
          {
            label: "FICO Score (Low)",
            path: "ficoLow",
            includes: ["FICO Low"],
          },
          {
            label: "FICO Score (Mid)",
            path: "ficoMid",
            includes: ["FICO Mid"],
          },
          {
            label: "FICO Score (High)",
            path: "ficoMax",
            includes: ["FICO High"],
          },
          {
            label: "Credit Report Date",
            path: "creditReportDate",
            includes: ["Report Date"],
          },
          {
            label: "Credit Authorization Date",
            path: "creditAuthDate",
            includes: ["Authorization"],
          },
          {
            label: "Background Check Date",
            path: "backgroundDate",
            includes: ["Background Check"],
          },
        ],
      },

      {
        label: "Background",
        path: "background",
        includes: ["Background", "Bankruptcy", "Felony", "Housing Events"],
        children: [
          {
            label: "Borrower Estimated FICO Range",
            path: "estimatedFICO",
            includes: ["Estimated FICO"],
          },
          {
            label: "Is Repeat Borrower",
            path: "repeatBorrowerFlag",
            includes: ["Repeat Borrower"],
          },
          {
            label: "Ever convicted of a felony?",
            path: "application_felony_conviction",
            includes: ["Felony"],
          },
          {
            label: "Ever convicted of financial/fraud-related crimes?",
            path: "application_financial_fraud_misdemeanor",
            includes: ["Fraud"],
          },
          {
            label: "Filed for bankruptcy in the last 5 years?",
            path: "bankruptcy_flag",
            includes: ["Bankruptcy"],
          },
          {
            label: "Ever owned a primary residence?",
            path: "firstTimeHomebuyer",
            includes: ["First Time Homebuyer"],
          },
          {
            label:
              "Any charge-offs, tax liens, pending litigation, or judgments?",
            path: "open_liens_judgments",
            includes: ["Liens", "Judgments"],
          },
          {
            label: "Charge Offs",
            path: "charge_offs",
            includes: ["Charge Off"],
          },
          { label: "Tax Liens", path: "tax_liens", includes: ["Lien"] },
          {
            label: "Financial Judgements",
            path: "financial_judgements",
            includes: ["Judgement"],
          },
          {
            label: "Pending Litigation",
            path: "pending_litigation",
            includes: ["Litigation"],
          },
          {
            label: "Past 3 yrs housing events",
            path: "housing_events",
            includes: ["Forbearance", "Mods", "Foreclosures", "Mortgage Lates"],
          },
          {
            label: "Time Since Last Housing Event",
            path: "time_since_housing_event",
            includes: ["Housing Event Time"],
          },
          {
            label: "Forbearance or Modification",
            path: "forbearance_or_modification",
            includes: ["Forbearance", "Modification"],
          },
          {
            label: "Mortgage Lates",
            path: "mortgage_lates",
            includes: ["Lates"],
          },
          {
            label: "Lis Pendens or Foreclosure",
            path: "foreclosure",
            includes: ["Foreclosure"],
          },
        ],
      },

      {
        label: "Entity Info",
        path: "entity-info",
        includes: ["Entity", "Ownership", "Guarantor"],
        children: [
          {
            label: "Entity Percent Ownership",
            path: "entityPercentOwnership",
            includes: ["Ownership"],
          },
          {
            label: "Is Guarantor?",
            path: "isGuarantor",
            includes: ["Guarantor"],
          },
        ],
      },

      {
        label: "ID Verification",
        path: "id-verification",
        includes: ["ID", "Driver's License", "Passport"],
        children: [
          {
            label: "ID Type",
            path: "borrowerIdType",
            includes: ["License", "Passport"],
          },
          {
            label: "Is Foreign National?",
            path: "foreignNationalFlag",
            includes: ["Foreign National"],
          },
        ],
      },

      {
        label: "Company Info",
        path: "company-info",
        includes: ["Company", "Role", "Direct Borrower", "Broker"],
        children: [
          { label: "Company Name", path: "company", includes: ["Company"] },
          { label: "Role", path: "role", includes: ["Role"] },
          {
            label: "Is Direct Borrower?",
            path: "directBorrower",
            includes: ["Direct"],
          },
          { label: "Is Broker?", path: "broker", includes: ["Broker"] },
        ],
      },

      {
        label: "Primary Address",
        path: "primary-address",
        includes: ["Primary Address", "Address"],
        // address renderer section; add specific subfields if/when enumerated
      },

      {
        label: "Experience",
        path: "experience",
        includes: [
          "Experience",
          "Fix & Flip",
          "Income Producing",
          "Construction",
        ],
        // experience groups are composite; keep high-level for search
        children: [
          {
            label: "Experience Summary",
            path: "borrowerExperienceSummary",
            includes: ["Summary"],
          },
          {
            label: "Fix and flips completed and sold",
            path: "ff_sold",
            includes: ["Fix Flips Sold"],
          },
          {
            label: "Income Producing Properties acquired",
            path: "income_producing_properties",
            includes: ["Income Producing"],
          },
          {
            label: "Fix & flips retained as rental",
            path: "ff_retained_as_rental",
            includes: ["Retained Rental"],
          },
          {
            label: "GC rehab completed and sold",
            path: "general_contractor_projects",
            includes: ["General Contractor"],
          },
          {
            label: "Ground up construction - sold",
            path: "guc_sold",
            includes: ["Ground Up Sold"],
          },
          {
            label: "Ground up construction - retained",
            path: "guc_retained_as_rental",
            includes: ["Ground Up Retained"],
          },
        ],
      },

      {
        label: "Additional Notes",
        path: "additional-notes",
        includes: ["Additional Notes", "Notes"],
        children: [
          {
            label: "Additional Borrower Notes",
            path: "additional_borrower_notes",
            includes: ["Notes"],
          },
        ],
      },
    ],
  },
];
